import { render, staticRenderFns } from "./AuthSignup.vue?vue&type=template&id=ffef81ae&scoped=true&"
import script from "./AuthSignup.vue?vue&type=script&lang=js&"
export * from "./AuthSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffef81ae",
  null
  
)

export default component.exports